import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

interface SearchTemplatesQuery {
  skip: string;
  limit: string;
  deleted: string;
  type: string;
}

interface LabFeature {
  key: string;
  name: string;
  details: {
    heading: string;
    body: string;
  };
  liveAt: string;
  enabledAt: string;
  visibleAt: string;
  default: boolean;
  toggleHidden: boolean;
}

const LocationsService = {
  getLocationById: (locationId: string) => requests(SERVICE_NAME.LOCATIONS_API).get(locationId),

  searchTemplates: (locationId: string, params: SearchTemplatesQuery) =>
    requests(SERVICE_NAME.LOCATIONS_API).get(`${locationId}/templates`, {
      params,
    }),

  restoreLocation: (locationId: string) =>
    requests(SERVICE_NAME.LOCATIONS_API).put(`${locationId}/restore-location`),

  searchFeatureFeedbacks: (featureKey: string, skip: number, limit: string) =>
    requests(SERVICE_NAME.LOCATIONS_API).get(
      `labs/feedbacks?${featureKey ? `featureKey=${featureKey}` : ""}${skip ? `&skip=${skip}` : ""
      }${limit ? `&limit=${limit}` : ""}`
    ),

  migrateCustomFields: (locationId: string) =>
    requests(SERVICE_NAME.LOCATIONS_API).post(
      `${locationId}/customFields/migrate`
    ),

  getLabsFeatures: (type: "location" | "company" = "location") =>
    requests(SERVICE_NAME.LOCATIONS_API).get(
      `labs/features?all=true&type=${type}`
    ),

  createLabsFeature: (body: LabFeature) =>
    requests(SERVICE_NAME.LOCATIONS_API).post("labs/features", body),

  updateLabsFeature: (id: string, body: LabFeature) =>
    requests(SERVICE_NAME.LOCATIONS_API).put(`labs/features/${id}`, body),

  deleteLabsFeature: (id: string) =>
    requests(SERVICE_NAME.LOCATIONS_API).delete(`labs/features/${id}`),

  updateLabsFeaturePosition: (id: string, after: string) =>
    requests(SERVICE_NAME.LOCATIONS_API).put(
      `labs/features/position/${id}`,
      null,
      {
        params: { after },
      }
    ),
  updateLocationEmail: (id:string, email: string) => requests(SERVICE_NAME.LOCATIONS_API).put(
    `${id}`,
    {email}
  ),
};
export default LocationsService;
